// extracted by mini-css-extract-plugin
export default {"left-addon":"left-addon__TzvWm"};